import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollReset from './components/ScrollReset';
import CookieConsent from './components/CookieConsent';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import Maintenance from './pages/services/Maintenance';
import Cybersecurity from './pages/services/Cybersecurity';
import Cloud from './pages/services/Cloud';
import Hosting from './pages/services/Hosting';
import Hardware from './pages/services/Hardware';
import AI from './pages/services/AI';
import Support from './pages/services/Support';
import AvisoLegal from './pages/legal/AvisoLegal';
import Privacidad from './pages/legal/Privacidad';
import Cookies from './pages/legal/Cookies';
import './App.css';
import { Helmet } from 'react-helmet';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <ScrollReset />
        <GoogleAnalytics />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<>
              <Helmet>
                <title>VGBComputers | Soluciones Informáticas para Empresas y Pymes</title>
                <meta name="description" content="Ofrecemos mantenimiento, seguridad y desarrollo web para pymes. Tu socio tecnológico de confianza para optimizar y proteger tu negocio. ¡Pide tu presupuesto!" />
              </Helmet>
              <Home />
            </>} />
            <Route path="/servicios" element={<>
              <Helmet>
                <title>Servicios Informáticos Profesionales | VGBComputers</title>
                <meta name="description" content="Descubre nuestra gama de servicios: mantenimiento proactivo, reparación de equipos, ciberseguridad avanzada y venta de material informático. Soluciones a tu medida." />
              </Helmet>
              <Services />
            </>} />
            <Route path="/servicios/ia" element={<AI />} />
            <Route path="/servicios/mantenimiento" element={<Maintenance />} />
            <Route path="/servicios/ciberseguridad" element={<Cybersecurity />} />
            <Route path="/servicios/cloud" element={<Cloud />} />
            <Route path="/servicios/hosting" element={<Hosting />} />
            <Route path="/servicios/hardware" element={<Hardware />} />
            <Route path="/servicios/soporte" element={<Support />} />
            <Route path="/sobre-nosotros" element={<>
              <Helmet>
                <title>Conoce Nuestro Equipo de Expertos | VGBComputers</title>
                <meta name="description" content="Somos un equipo de técnicos apasionados por la tecnología, dedicados a ofrecer un servicio cercano y eficaz. Conoce nuestra historia y compromiso con tu éxito." />
              </Helmet>
              <About />
            </>} />
            <Route path="/clientes" element={<Clients />} />
            <Route path="/contacto" element={<>
              <Helmet>
                <title>Contacta con VGBComputers | Presupuesto sin Compromiso</title>
                <meta name="description" content="¿Necesitas ayuda con tu sistema informático? Rellena nuestro formulario, llámanos o visítanos. Ofrecemos una primera consulta sin compromiso para entender tus necesidades." />
              </Helmet>
              <Contact />
            </>} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
        </main>
        <ScrollToTop />
        <CookieConsent />
        <Footer />
      </div>
    </Router>
  );
}

export default App;